module.exports = __webpack_public_path__ + "img/hr-tree-03-g-leaves.17e9b655.png";